import React from "react";
import {
  capitalizeFirstLetter,
  currencyFormatter,
} from "./../../utils/display";

export default ({ name, sellPercentage, limit, submissionMethod }) => (
  <tr>
    <td>{name}</td>
    <td>{`${sellPercentage}%`}</td>
    <td>{currencyFormatter(limit.max) || "N/A"}</td>
    <td>{capitalizeFirstLetter(submissionMethod)} </td>
  </tr>
);
